// import Teachr from "./Teachr";

export default class TeachrContact  {

    readonly "@id"?: string;
    readonly "@type"?: string;
    readonly "@context"?: string;
    id?: Number;
    readonly lastModificationDatetime?: Date;

    readonly creationDatetime?: Date;
    readonly key? : string

    step : Number
    status? : boolean
    studentName?: string
    level?: number
    firstName?: string
    name?: string
    birthName?: string
    mail: string
    phoneNumber?: string
    gender?: string
    birthDay?: string | null
    isBornFrance?: boolean
    zipCode?: string 
    city?: string
    address?: string
    country?: string
    iban?: string
    bic?: string
    brand?: string
    teachr: string | null
    acceptMarketingEmail?: boolean
    isDelete?: boolean
    isNotify?: boolean
    /** Adresse du domicile (saisie manuelle) persistée en JSON pour la reprise/refresh. */
    addressObject?: any
    /** Statut de reprise de l'endpoint consolidé de création des comptes (géré côté backend). */
    aiciProcess?: any
    constructor(
        step: Number,
        mail: string,
        teachr: string | null
    ) {
        this.step = step
        this.mail = mail
        this.teachr = teachr
    }

}
